<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.preApprovedTemplateDetails')}}
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body card_body_layout">
                    <div class="row">

                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.templateId')}}</label>
                                    <h4 class="user_info_txt">{{ model.templateCode }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.templateName')}}</label>
                                    <h4 class="user_info_txt">{{ model.name }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.classification')}}</label>
                                    <h4 class="user_info_txt">{{ classificationLabel(model.classification) }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.createdDate')}}</label>
                                    <h4 class="user_info_txt">{{ formatDate(model.createdDate) }}</h4>
                                </div>
                                <div class="col-sm-8 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.templateDescription')}}</label>
                                    <h4 class="user_info_txt">{{ model.description || '-' }}</h4>
                                </div>

                                <div class="col-md-12 mt-4">
                                    <div class="d-inline-flex align-items-center mb-2" style="gap: 12px;">
                                        <label class="user_info_header mb-0">{{$t('shared.templateContent')}}</label>
                                        <button type="button"
                                                class="btn"
                                                :title="templateTextDir === 'ltr' ? $t('shared.ltr') : $t('shared.rtl')"
                                                @click="templateTextDir = templateTextDir === 'ltr' ? 'rtl' : 'ltr'"
                                                style="width: 1.5rem; height: 1.5rem; min-width: 1.5rem; padding: 0; display: inline-flex; align-items: center; justify-content: center; border: 1px solid #1976d2; background: transparent; border-radius: 4px; line-height: 1;">
                                            <i :class="templateTextDir === 'ltr' ? 'fas fa-align-left' : 'fas fa-align-right'" aria-hidden="true" style="font-size: 0.75rem;"></i>
                                        </button>
                                    </div>
                                    <div v-if="hasTemplateVariables">
                                        <table class="table table-bordered text-center">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50%;">{{$t('shared.templateContent')}}</th>
                                                    <th style="width: 50%;">{{$t('shared.previewContent')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td :dir="templateTextDir" :style="{ textAlign: templateTextDir === 'rtl' ? 'right' : 'left', whiteSpace: 'pre-wrap' }">{{ formatTemplateContentForDisplay(baseTemplateContent) }}</td>
                                                    <td :dir="templateTextDir" :style="{ textAlign: templateTextDir === 'rtl' ? 'right' : 'left', whiteSpace: 'pre-wrap' }">{{ formatTemplateContentForDisplay(substitutedText) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <textarea v-else
                                              rows="4"
                                              class="form-control"
                                              :dir="templateTextDir"
                                              :style="{
                                                  resize: 'none',
                                                  backgroundColor: '#f8f9fa',
                                                  color: '#000',
                                                  fontWeight: '500',
                                                  textAlign: templateTextDir === 'rtl' ? 'right' : 'left'
                                              }"
                                              v-model="substitutedText"
                                              readonly>
                                    </textarea>
                                </div>

                                <div class="col-md-12 mt-4" v-if="variablesMapping.length">

                                    <label class="user_info_header mb-3">
                                        {{ $t('shared.templateVariables') }}
                                    </label>

                                    <table class="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th style="width: 40%;">Variable</th>
                                                <th style ="width: 60%;">Value</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(item,index) in variablesMapping"
                                                :key="index">

                                                <td>{{ item.key }}</td>
                                                <td>{{ item.value }}</td>

                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/PreApprovedTemplates" tag="a" class="link_secondary">{{$t('shared.back')}}</router-link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>